export const creditData = [
    {
        details: [
            {
                label: "Direction éditoriale",
                name: "Aimé Richard HAJALALAINA",
                role: "Président",
                work: "Université de Fianarantsoa"
            },
            {
                label: "Coordination du Comité Scientifique",
                name: "Xavier Amelot,",
                role: "",
                work: "Université Bordeaux Montaigne, UMR PASSAGES"
            },
            {
                label: "Secrétariat de rédaction",
                name: "Anouk Agrech,",
                role: "",
                work: "Université Bordeaux Montaigne, UMR PASSAGES"
            },
            {
                label: "Cartographie",
                name: "Olivier Pissoat,",
                role: "",
                work: "CNRS, UMR PASSAGES"
            },
            {
                label: "Infrastructure de Données Géographiques",
                name: "Mathias Rouan,",
                role: "",
                work: "CNRS, UMR Entropie"
            },
            {
                label: "Infrastructure de Données Géographiques",
                name: "Jacques Aimé Razafindragy,",
                role: "",
                work: "Université de Fianarantsoa"
            },
            {
                label: "Création et maintenance du site de la revue",
                name: "ITDC, (https://itdcmada.mg/)",
                role: "",
                work: "",
                link: "https://itdcmada.mg/"
            },
            {
                label: "Hébergement du site",
                name: "Université de Fianarantsoa",
                role: "",
                work: ""
            },
            {
                label: "Financement",
                name: "Projet MadAtlas, (https://www.madatlas.mg/)",
                role: "",
                work: "",
                link: "https://www.madatlas.mg/"
            }
        ]
    }
];